import { create } from 'zustand'

import { initialCommunityGalleryFiltersState } from './slices/communityGalleryFilters'
import { initialDccBridgeState } from './slices/dccBridge'
import { initialExportState } from './slices/export'
import { initialFiltersState } from './slices/filters'
import { initialGenerationState } from './slices/generation'
import { initialModelSettingsState } from './slices/modelSettings'
import { initialRemeshSettingsState } from './slices/remeshSettings'
import { initialSchemaState } from './slices/schema'
import { initialStaticViewerState } from './slices/staticViewer'
import { initialSubscriptionState } from './slices/subscription'
import { initialTextureSettingsState } from './slices/textureSettings'
import { initialUiState } from './slices/ui'
import { initialViewerState } from './slices/viewer'

const initialState = {
  ...initialCommunityGalleryFiltersState,
  ...initialDccBridgeState,
  ...initialExportState,
  ...initialFiltersState,
  ...initialGenerationState,
  ...initialModelSettingsState,
  ...initialRemeshSettingsState,
  ...initialSubscriptionState,
  ...initialTextureSettingsState,
  ...initialSchemaState,
  ...initialStaticViewerState,
  ...initialUiState,
  ...initialViewerState,
}

export const useThreeDStudioStore = create(() => initialState)

export const threeDStudioStore = useThreeDStudioStore
